import { combineReducers } from 'redux';
import AppReducer from './AppReducer';
import OrderReducer from './OrderReducer';
import AlertsReducer from './AlertsReducer';
import LoadingReducer from './LoadingReducer';
import BusinessReducer from './BusinessReducer';
import CatalogReducer from './CatalogReducer';
import CustomerReducer from './CustomerReducer';
import UIReducer from './UIReducer';

export default combineReducers({
    app: AppReducer,
    business: BusinessReducer,
    catalog: CatalogReducer,
    customer: CustomerReducer,
    order: OrderReducer,
    alerts: AlertsReducer,
    loading: LoadingReducer,
    ui: UIReducer
});
